import { Button } from '../../Button';
import { EmptyStateConfigProps } from '../types';

export function TableDefaultEmptyState({
  title = 'No results found',
  description = 'Try adjusting your filters or search terms',
  action,
}: EmptyStateConfigProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-8">
      <div className="text-center">
        <h3 className="txt-medium-bold text-text-primary mb-1">{title}</h3>
        <p className="txt-small-regular text-text-tertiary">{description}</p>
        {action && (
          <Button
            variant="secondary"
            onClick={action.onClick}
            size="sm"
            className="mt-4"
          >
            {action.text}
          </Button>
        )}
      </div>
    </div>
  );
}
